$(document).ready(() => {
    $('.filter-list li').click(function(e) {
        $(this).find('.news-filter-type').slideToggle();
        $(this).find('.category-filter-type').slideToggle();
    });
});



// WEBPACK FOOTER //
// ./src/js/filters.js